export const state = () => ({
  permissions: [],
  currentPermission: null,
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  permissions: (state) => state.permissions,
  currentPermission: (state) => state.currentPermission,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_PERMISSIONS(state, data) {
    if (data.content) {
      state.permissions = data.content
      state.pagination = {
        page: data.number,
        size: data.size,
        totalElements: data.totalElements,
        totalPages: data.totalPages
      }
    } else {
      state.permissions = Array.isArray(data) ? data : []
    }
  },
  SET_CURRENT_PERMISSION(state, permission) {
    state.currentPermission = permission
  },
  ADD_PERMISSION(state, permission) {
    state.permissions.push(permission)
  },
  UPDATE_PERMISSION(state, permission) {
    const index = state.permissions.findIndex(p => p.id === permission.id)
    if (index !== -1) {
      state.permissions.splice(index, 1, permission)
    }
  },
  REMOVE_PERMISSION(state, permissionId) {
    state.permissions = state.permissions.filter(p => p.id !== permissionId)
  }
}

export const actions = {
  async fetchPermissions({ commit }, { page = 0, size = 10, sortBy = 'code', direction = 'asc' } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get('/auth/api/permissions', {
        params: { page, size, sortBy, direction }
      })
      commit('SET_PERMISSIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch permissions')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPermission({ commit }, permissionId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/permissions/${permissionId}`)
      commit('SET_CURRENT_PERMISSION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch permission')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createPermission({ commit }, permissionData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/permissions', permissionData)
      commit('ADD_PERMISSION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to create permission')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deletePermission({ commit }, permissionId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete(`/auth/api/permissions/${permissionId}`)
      commit('REMOVE_PERMISSION', permissionId)
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to delete permission')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

